export const screenSize = {
  width: 1920,
  height: 1080,
};
